export const HANDLE_REQUEST_REPORT_REQUEST_FAILURE =
  'feature/vehicleHistory/HANDLE_REQUEST_REPORT_REQUEST_FAILURE';

export const HANDLE_REQUEST_REPORT_REQUEST =
  'feature/vehicleHistory/HANDLE_REQUEST_REPORT_REQUEST';

export const HANDLE_REQUEST_REPORT_SUCCESS =
  'feature/vehicleHistory/HANDLE_REQUEST_REPORT_SUCCESS';
